import { defineComponent, useAttrs, computed, createElementBlock, openBlock, normalizeStyle, normalizeClass, renderSlot, createElementVNode, mergeProps, createCommentVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _hoisted_1 = ["checked"];
const _hoisted_2 = {
  key: 0,
  class: "ml-2 text-sm"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PCheckbox",
    inheritAttrs: false
  },
  __name: "p-checkbox",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const allAttrs = useAttrs();
    const attrs = computed(() => {
      const { class: classes, style: style2, ...rest } = allAttrs;
      return rest;
    });
    const style = computed(() => {
      return allAttrs.style;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("label", {
        class: normalizeClass(["inline-flex items-center", [{ hidden: _ctx.$attrs.hidden }, _ctx.$attrs.class]]),
        style: normalizeStyle(style.value)
      }, [
        renderSlot(_ctx.$slots, "label-before", {}, void 0, true),
        createElementVNode("input", mergeProps({
          type: "checkbox",
          class: "h-4 w-4 shrink-0 appearance-none rounded border border-p-gray-30 bg-surface duration-100 ease-in-out checked:border-none checked:bg-primary disabled:opacity-50"
        }, attrs.value, {
          checked: __props.modelValue,
          onChange: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event.target.checked))
        }), null, 16, _hoisted_1),
        renderSlot(_ctx.$slots, "label", {}, () => [
          __props.label ? (openBlock(), createElementBlock("div", _hoisted_2, toDisplayString(__props.label), 1)) : createCommentVNode("", true)
        ], true)
      ], 6);
    };
  }
});
const pCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-81cd6154"]]);
export {
  pCheckbox as default
};
